/**
 * Shared shell theme tokens. Single source of truth for the Office/Fluent brand
 * accent used across the shell's UI (sign-in button, menu drawer, GraphConnect),
 * so the literal isn't copied per component.
 */

/** Office/Fluent brand accent (the single highlight color the shell uses). */
export const OFFICE_ACCENT = "#0F6CBD";
